import { render, staticRenderFns } from "./AppDownloads.vue?vue&type=template&id=709cd768&scoped=true"
import script from "./AppDownloads.vue?vue&type=script&lang=js"
export * from "./AppDownloads.vue?vue&type=script&lang=js"
import style0 from "./AppDownloads.vue?vue&type=style&index=0&id=709cd768&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "709cd768",
  null
  
)

export default component.exports